const htmlFrameFitMode = {
    FitToOriginal: 1,
    FitToWidth: 2
}

export default htmlFrameFitMode;